import TopNavbar from 'src/components/admin/navigation/topNav';
import Footer from 'src/components/Footer';
import ScrollTop from 'src/components/ScrollTop';
import { propsBasicLayoutType } from 'utils/proptypes';

const BasicLayout = (props: propsBasicLayoutType & { viewMode?: 'mobile' | 'desktop' }) => {
   const { children, viewMode } = props;


   return (
      <div className="flex flex-col w-full h-screen bg-white">
         <ScrollTop />
         {/* Navigation bar */}
         <TopNavbar darkMode={true} />

         {/* Body content */}
         <main className="flex w-full flex-1 justify-center">{children}</main>

         {/* Footer */}
         <Footer viewMode={viewMode} />
      </div>
   );
};

export default BasicLayout;
